<!--  -->
<template>
  <div>
    <div class="box">
      <div class="center">
        <div class="text">平台简介</div>
        <!-- <div class="line"></div> -->
        <div class="text">联系我们</div>
        <!-- <div class="line"></div> -->
        <div class="text">版权声明</div>
        <!-- <div class="line"></div> -->
        <div class="text">平台公众号</div>
      </div>
      <div class="info">
        <img src="../assets/img/bottom-icon.png" alt="" class="icoimg">
        <span>京公网安备 11010802020185号</span>
        <span class="info-text">京ICP备15011138号</span>
        <span>版权所有：中国招标公共服务平台有限公司</span>

      </div>

      <div class="info">
        <div>{{ cnzzContent }}</div>
      </div>




    </div>
  </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, onMounted, nextTick, onUnmounted } from 'vue'



const cnzzContent = ref('');


let timerId = null;
var currentUrl = window.location.href;

// 定时器执行的函数  
const checkCnzzLinks = () => {

  let cnzzDiv = {}
  // 检查地址中是否包含 "remotebidevaluation.cebpubservice.com"
  if (currentUrl.includes("remotebidevaluation.cebpubservice.com")) {
     cnzzDiv = document.getElementById('cnzz_stat_icon_1281408062');
  } else {
     cnzzDiv = document.getElementById('cnzz_stat_icon_1281408017');
  }


  if (!cnzzDiv) return;

  const links = cnzzDiv.querySelectorAll('a');
  const linkTexts = Array.from(links).map(link => link.textContent.trim());

  if (linkTexts.length > 0 && cnzzContent.value.trim() === '') {
    const links = cnzzDiv.querySelectorAll('a');
    Array.from(links).map(link => link.textContent.trim()).forEach(link => {
      cnzzContent.value += link;
    });
  }

  // 如果cnzzContent已经有值，则停止定时器  
  if (cnzzContent.value.trim() !== '') {
    clearInterval(timerId);

    timerId = null;

  }
};





onMounted(() => {



  const cnzzDiv = document.createElement('div');

  if (currentUrl.includes("remotebidevaluation.cebpubservice.com")) {
    cnzzDiv.id = 'cnzz_stat_icon_1281408062';
  } else {
    cnzzDiv.id = 'cnzz_stat_icon_1281408017';
  }





  cnzzDiv.style.fontSize = '16px';
  cnzzDiv.style.width = '100%';
  cnzzDiv.style.textAlign = 'center';
  cnzzDiv.style.display = 'none'; // 或者根据需求设置  

  // 创建一个 script 元素  
  const cnzzScript = document.createElement('script');

  if (currentUrl.includes("remotebidevaluation.cebpubservice.com")) {
    cnzzScript.src = 'https://s4.cnzz.com/z.js?id=1281408062&online=1&show=line';
  } else {
    cnzzScript.src = 'https://s4.cnzz.com/z.js?id=1281408017&online=1&show=line';
  }




  

  cnzzScript.type = 'text/javascript';

  // 选择一个父元素来插入这些元素，这里以 #app 为例  
  const mountPoint = document.getElementById('app');
  mountPoint.appendChild(cnzzDiv);



  // 插入 script 元素  
  document.body.appendChild(cnzzScript);


  timerId = setInterval(checkCnzzLinks, 1000);




});

// 组件卸载时断开观察者，避免内存泄漏  
onUnmounted(() => {
  clearInterval(timerId);


});


</script>
<style lang="scss" scoped>
.box {
  width: 100%;
  padding: 55px 0 35px 0;
  box-sizing: border-box;
  background: #F7F7F8;
  z-index: 999;

  .center {
    display: flex;
    width: 600px;
    height: 14px;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    // margin-top: 55px;
  }

  .text {
    color: #000;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 0 13px;
  }

  .line {
    width: 2px;
    height: 100%;
    background-color: #A3A3A3;
    margin: 0 5px 0 5px;
  }
}

.info {
  display: flex;
  // width: 600px;
  height: 14px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  color: #888;


  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 10px;
}

.icoimg {
  width: 20px;
  height: 20px;
}

.info-text {
  margin: 0 10px 0 10px;
}
</style>